import React from 'react';
import { images } from '../data';
import { useTranslation } from 'react-i18next';


export default function Hero({ copy }) {

  const { t } = useTranslation();

  const lines = (t('kidoHero.welcome')).split('\n');
  return (
    <section className="kido-hero" id="top">
      <div className="kido-hero-copy">
        <p className="kido-eyebrow">{copy.label}</p>
        <h1>
          {lines.map((line, i) => (
            <span key={line}>{line}{i === 0 && <br />}</span>
          ))}
        </h1>
        <p className="kido-hero-sub">{(t('kidoHero.subtitle'))}</p>
        <a className="kido-yellow-button" href="#shop">{(t('kidoHero.cta'))}<span>↗</span></a>
      </div>
      <div className="kido-hero-art">
        <div className="kido-sun-shape" />
        <div className="kido-hero-note">თამაში<br />იწყება აქ</div>
        <div className="kido-hero-image"><img src={images.sunDress} alt="Coral children's dress" /></div>
        <div className="kido-sticker">სიხარული<br /><strong>100%</strong></div>
      </div>
    </section>
  );
}
